module.exports = __webpack_public_path__ + "img/learning-mentor-avatar.248ee3ca.svg";